import COLORS from './colors';

const globalStyles = `
  html,
  body {
    height: 100%;
    font-family: 'Lato', sans-serif;
    font-size: 18px;
    color: ${COLORS.black};
    -webkit-font-smoothing: antialiased;
  }

  body {
    margin: 0;
    padding: 0;
  }

  main,
  aside,
  details {
    display: block;
  }

  summary {
    display: block;
  }

  #root {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  button,
  input,
  label {
    font-family: inherit;
  }

  .react-grid-item.react-grid-placeholder {
    background: ${COLORS.primary_100} !important;
    opacity: 1 !important;
  }

  .react-resizable-handle {
    background-image: none !important;
  }

  .react-resizable-handle::after {
    border: none !important;
  }
`;

export default globalStyles;
